module.exports = __webpack_public_path__ + "static/media/05-cht.fa4b5bc0.png";